/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{_ as e}from"../../../chunks/tslib.es6.js";import{parameter as o,ShaderTechniqueConfiguration as r}from"../webgl-engine/core/shaderTechnique/ShaderTechniqueConfiguration.js";class s extends r{constructor(){super(...arguments),this.haze=!1}}e([o()],s.prototype,"haze",void 0);export{s as ChapmanAtmosphereTechniqueConfiguration};
